<template>
  <div class="sign">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item, index) in details.carouselPics" :key="index">
        <img :src="item && item.url" class="swipe-img" alt="">
      </van-swipe-item>
    </van-swipe>
    <div class="img-div">
      <div class="div-txt">全年培训计划</div>
      <img src="@/assets/images/zone/img19.png" class="img-top">
    </div>
    <div class="con-imgs">
      <img v-for="(item, index) in details.planPics" class="img" :key="index" :src="item && item.url" alt="">
    </div>
    <template v-if="zoneRoles && Object.keys(zoneRoles).length > 0">
      <div class="sign-btn" v-if="!isSigin" @click="handleConfirm">立即报名</div>
      <div class="sign-btn" v-else @click="handleClick">进入</div>
    </template>
  </div>
</template>
<script>
import { signDetails, confirmSign, roleDetails } from '@/api/zone'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data () {
    return {
      details: {},
      zoneRoles: {}
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    isSigin () {
      return `${this.userInfo.memberType}` === '1' ||
      (`${this.userInfo.memberType}` === '0' && `${this.zoneRoles.studentSign}` === '1') ||
      (`${this.userInfo.memberType}` === '0' && `${this.zoneRoles.tutorSign}` === '1')
    }
  },
  mounted () {
    if (!this.$route.query.areaId) {
      return this.$router.push('/zoneList?tab=ntc')
    }
    roleDetails({
      areaId: this.$route.query.areaId,
      userId: this.userInfo.id
    }).then(res => {
      this.zoneRoles = res.data
      // sessionStorage.getItem('roleResult', JSON.stringify(res.data))
    })
    signDetails({
      areaId: this.$route.query.areaId
    }).then(res => {
      this.details = res.data
    })
  },
  methods: {
    handleClick () {
      console.log(this.zoneRoles.studentStatus, '-=-=-')
      if (`${this.zoneRoles.studentStatus}` === '2') {
        this.$toast('您已被专区管理员限制访问，请联系管理员！')
        return
      }
      this.$router.push({
        path: `/zoneDetails?areaId=${this.$route.query.areaId}`
      })
    },
    handleConfirm () {
      if (`${this.zoneRoles.studentStatus}` === '2') {
        this.$toast('您已被专区管理员限制访问，请联系管理员！')
        return
      }
      let params = {
        'areaId': this.$route.query.areaId,
        'userId': this.userInfo.id
      }
      confirmSign(params).then(res => {
        if (res.code === 0) {
          this.$toast('报名成功')
          setTimeout(() => {
            this.$router.push({
              path: `/zoneDetails?areaId=${this.$route.query.areaId}`
            })
          }, 1500)
        }
      }).catch((err) => {
        this.$toast(err.msg)
      })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.sign {
  background: #F9F8F7;
  min-height: 100vh;
}

.my-swipe {
  width: 100%;
  height: 177px;

  .swipe-img {
    width: 100%;
    height: 177px;
    object-fit: cover;
    display: block;
  }
}

.con-imgs {
  .img {
    display: block;
    width: 100%;
  }
}

.img-div {
  position: relative;
  padding: 20px 0;

  .div-txt {
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    font-weight: 500;
    color: #EB1700;
    position: relative;
    z-index: 9;
  }

  .img-top {
    width: 343px;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    top: 20px;
  }
}

.sign-btn {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background: #EB1700;
  width: 343px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/sign.vue